export function groupByCounty(array, string) {
  if (string == " " || string == "Filter by County") {
    return array
  } else {
    return array.filter(item => item?.node.county === string)
  }
}
